// extracted by mini-css-extract-plugin
export default {"wrapper":"Nz-z","button":"Oz-z","alternate":"Pz-z","disabled":"Qz-z","paymentWarning":"Rz-z","fadeIn":"Sz-z"};